// Version : 0.0.1
// Author :
// LastEdit : 
// Last ADD : INITIAL CREATION
// MODIFIED DATE: 

import ThriftReportActionTypes from './thrift-report.types';

const INITIAL_STATE = {
	// FETCH THRIFT REPORT RESPONSE
	fetchThriftReportResponse: null,
};

const thriftReportReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** *********************  START OF FETCH THRIFT REPORT  ******************** */
		case ThriftReportActionTypes.FETCH_THRIFT_REPORT_SUCCESS:
			return {
				...state,
				fetchThriftReportResponse: action.payload,
			};

		case ThriftReportActionTypes.FETCH_THRIFT_REPORT_FAILURE:
			return { ...state, fetchThriftReportResponse: action.payload };

		case ThriftReportActionTypes.FETCH_THRIFT_REPORT_RESPONSE_CHANGED:
			return {
				...state,
				fetchThriftReportResponse: null,
			};
		/** *********************  END OF FETCH THRIFT REPORT  ******************** */

		default:
			return state;
	}
};

export default thriftReportReducer;

